import { render, staticRenderFns } from "./right-first.vue?vue&type=template&id=3c3502d2&scoped=true&"
import script from "./right-first.vue?vue&type=script&lang=js&"
export * from "./right-first.vue?vue&type=script&lang=js&"
import style0 from "./right-first.vue?vue&type=style&index=0&id=3c3502d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3502d2",
  null
  
)

export default component.exports